/**
 * Place to store globally relevant presets such as standard animation speed for
 * and easing functions for javascript animations.
 */
window.o_global = window.o_global || {};

window.o_global.pali = window.o_global.pali || {};

window.o_global.pali.presets = {
  animationSpeed: 500, // Base animation speed for every kind of js animation.
  animationEasing: "easeInOutCubic", // Standard easing function for js animation.
};
